// extracted by mini-css-extract-plugin
module.exports = {"layout":"_5D3WXpzT","main":"_5D2JL0c5"};